export default {"src":"/_next/static/image/public/images/aster_secure_new.fe536ac4bbedded79a407c170018482e.svg","height":244,"width":777};